import React, { useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  CircularProgress,
  makeStyles,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { TextField as TextF } from '@material-ui/core';
import { Button as MuiButton } from '@material-ui/core';
import background from '../new.png';
import logo from '../02.png';
import logo2 from '../logo.svg';

const useStyles = makeStyles((theme) => ({
  field: {
    marginBottom: theme.spacing(2),
    width: '100%',
    '& .MuiOutlinedInput-root': {
      '& fieldset': { borderColor: '#ccc' },
      '&:hover fieldset': { borderColor: '#009688' },
      '&.Mui-focused fieldset': { borderColor: '#009688' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#009688' },
  },
  card: {
    textAlign: 'center',
    padding: '30px 36px',
    background: '#fff',
    boxShadow: '0px 10px 30px rgba(0,0,0,0.15)',
    borderRadius: 12,
    minWidth: 400,
    maxWidth: 440,
  },
  submitBtn: {
    backgroundColor: '#009688',
    color: '#fff',
    height: 48,
    fontSize: 15,
    fontWeight: 600,
    marginTop: 4,
    '&:hover': { backgroundColor: '#00796b' },
  },
  divider: {
    border: 'none',
    borderTop: '1px solid #eee',
    margin: '16px 0',
  },
}));

const CivilConferenceLogin = () => {
  const classes = useStyles();
  const history = useHistory();

  const [instituteId, setInstituteId] = useState('');
  const [registrationId, setRegistrationId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!instituteId) {
      setError('Institute ID is required.');
      return;
    }
    setError('');
    setLoading(true);

    try {
      // If registrationId is provided, fetch existing applicant data and pre-fill form
      if (registrationId) {
        const res = await fetch(
          `${process.env.REACT_APP_API_ROOT}/public/online/admission/single/applicant/info?instituteId=${instituteId}&registrationId=${registrationId}`
        );
        const data = await res.json();

        if (data?.messageType === 1 && data?.item) {
          // Store applicant info in sessionStorage so the form can pre-fill it
          sessionStorage.setItem('civilConferenceInfo', JSON.stringify(data.item));
          history.push(`/civil-conference-form/${instituteId}`);
        } else {
          setError(data?.message || 'No applicant found with this Registration ID.');
        }
      } else {
        // New applicant — just verify institute exists, then proceed
        const res = await fetch(
          `${process.env.REACT_APP_API_ROOT}/public/online-applicantion/institute-info/${instituteId}`
        );
        const data = await res.json();

        if (data?.item) {
          sessionStorage.removeItem('civilConferenceInfo');
          history.push(`/civil-conference-form/${instituteId}`);
        } else {
          setError('Institute not found. Please check your Institute ID.');
        }
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <img src={logo} style={{ height: 170, width: '100%' }} alt="Logo" />
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        style={{
          minHeight: '74vh',
          backgroundImage: `url(${background})`,
          width: '100%',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <br />
        <div className={classes.card}>
          <img src={logo2} style={{ height: 80 }} alt="Brand Logo" />

          <Typography
            variant="h5"
            component="h1"
            style={{ color: '#009688', marginTop: 10, fontWeight: 700, lineHeight: 1.3 }}
          >
            Civil Engineering Conference
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ color: '#777', marginBottom: 20 }}
          >
            Conference Registration Portal
          </Typography>

          <form onSubmit={handleSubmit}>
            {/* Institute ID — always required */}
            <TextF
              label="Institute ID *"
              variant="outlined"
              size="small"
              type="number"
              className={classes.field}
              value={instituteId}
              onChange={(e) => setInstituteId(e.target.value)}
            />

            <hr className={classes.divider} />

            {/* Registration ID — optional, for existing applicants */}
            <Typography variant="body2" style={{ color: '#555', marginBottom: 8, textAlign: 'left' }}>
              Already registered? Enter your Registration ID to view/edit your application.
            </Typography>
            <TextF
              label="Registration ID (optional)"
              variant="outlined"
              size="small"
              type="number"
              className={classes.field}
              value={registrationId}
              onChange={(e) => setRegistrationId(e.target.value)}
            />

            {error && (
              <Typography variant="body2" style={{ color: 'red', marginBottom: 10 }}>
                {error}
              </Typography>
            )}

            {loading ? (
              <CircularProgress size={28} style={{ color: '#009688', marginTop: 8 }} />
            ) : (
              <MuiButton
                type="submit"
                variant="contained"
                fullWidth
                className={classes.submitBtn}
              >
                {registrationId ? 'View My Application' : 'New Registration'}
              </MuiButton>
            )}
          </form>
        </div>
      </Grid>
    </>
  );
};

export default CivilConferenceLogin;
